import React, { FC, useEffect, RefObject, useRef, useCallback } from 'react';
import IComponentProps from 'interfaces/IComponentProps';
import styled from 'styled-components';
import colors from 'const/style/colors';
import fonts from 'const/style/fonts';

interface IPopOverProps extends IComponentProps {
  anchor: RefObject<HTMLElement>;
  open:boolean;
  arrow?:'TOP'|'BOTTOM'|'LEFT'|'RIGHT'|'TOP_LEFT'|'TOP_RIGHT'|'BOTTOM_LEFT'|'BOTTOM_RIGHT'|'LEFT_TOP';
}

const ARROW_WIDTH = 20;
const ARROW_HEIGHT = 15;

const PopoverFrame = styled.div<Partial<IPopOverProps>>`
  position:fixed;
  padding: 14px 20px;
  min-height: 100px;
  dispaly:flex;
  flex-grow:row;
  justify-content:center;
  align-items:center;
  z-index:2;
  
  ${fonts.H3_White};
  background: ${colors.C3C3C3C};
  box-shadow: 0px 10px 16px #00000038;
  opacity: 0.94;
  border-radius:15px;

  visibility:hidden;
  &.open {
    visibility:visible;
    animation: popover 0.5s forwards;
    transform-origin: ${({arrow})=>{
      switch(arrow) {
        case 'LEFT':
          return 'center left';
        case 'RIGHT':
          return 'center right';
        case 'TOP':
          return 'top center';
        case 'BOTTOM':
          return 'bottom center';
        case 'TOP_LEFT':
        case 'LEFT_TOP':
          return 'top left';
        case 'BOTTOM_LEFT':
          return 'bottom left';
        case 'BOTTOM_RIGHT':
          return 'bottom right';
      }
    }}
  }
  &:before {
    position:absolute;
    content:' ';
    font-size:0;
    width:0;
    height:0;
    border-style:solid;
    border-width: ${ARROW_HEIGHT}px ${ARROW_WIDTH}px ;
    border-color:transparent;
  }
  &.arrow-TOP:before {
  }
  &.arrow-TOP_LEFT:before {
    left:0;
    top: 0;
    margin-top:-${ARROW_HEIGHT}px;
    border-left-color:${colors.C3C3C3C};
    /* border-bottom-left-radius:${ARROW_WIDTH}px; */
  }
  &.arrow-LEFT:before {
    left:${-ARROW_WIDTH*2}px;
    top: 50%;
    margin-top:-${ARROW_WIDTH}px;
    border-right-color:${colors.C3C3C3C};
  }
  &.arrow-RIGHT:before {
    right:${-ARROW_WIDTH*2}px;
    top:50%;
    margin-top:-${ARROW_WIDTH}px;
    border-left-color:${colors.C3C3C3C};
  }
  &.arrow-BOTTOM:before {
  }
  &.arrow-BOTTOM_LEFT:before {
    left:0;
    bottom:${-ARROW_HEIGHT}px;
    border-left-color:${colors.C3C3C3C};
  }
  &.arrow-BOTTOM_RIGHT:before {
    right:0;
    bottom:${-ARROW_HEIGHT}px;
    border-right-color:${colors.C3C3C3C};
  }

  @keyframes popover {
    0% {transform:scale(1.0); opacity:0.1;}
    90% {transform:scale(1.1); opacity:0.9;}
    100% {transform:scale(1.0); opacity:1.0;}
  }
`;
const Dimmer = styled.div`
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index:1;
  cursor: not-allowed;
`;

const Popover:FC<IPopOverProps> = ({anchor, open, children, arrow='LEFT'})=>{
  const ref = useRef<HTMLElement>(null);
  const onResize = useCallback(() =>{
    if(anchor.current && ref.current) {
      // const {clientTop, clientLeft, clientWidth, clientHeight} = anchor.current;
      const {top: anchorTop, left: anchorLeft, width: anchorWidth, height: anchorHeight} = anchor.current.getBoundingClientRect();
      const {width:refWidth, height:refHeight} = ref.current.getBoundingClientRect();
      let topDest = anchorTop;
      //  + clientHeight;
      let leftDest = anchorLeft;
      //  + clientWidth;
      switch(arrow) {
        //TODO: 일단 필요한거만 구현합니당..ㅋㅋ 필요한거 있으면 대충 만들어쓰셈
        case 'LEFT':
          topDest += anchorHeight/2 -refHeight/2;
          leftDest += anchorWidth + ARROW_WIDTH;
          break;
        case 'RIGHT':
          topDest += anchorHeight/2 -refHeight/2;
          leftDest -= refWidth + ARROW_WIDTH;
          break;
        case 'TOP':
          topDest += refHeight/2 + ARROW_WIDTH;
          leftDest += anchorWidth/2;
          break;
        case 'BOTTOM':
          topDest -= anchorWidth/2 + ARROW_WIDTH;
          leftDest += anchorWidth/2;
          break;
        case 'TOP_LEFT':
          topDest += refHeight/2 + ARROW_WIDTH;
          break;
        case 'LEFT_TOP':
          leftDest += anchorWidth + ARROW_HEIGHT;
          break;
        case 'BOTTOM_LEFT':
          topDest -= refHeight + ARROW_HEIGHT;
          break;
        case 'BOTTOM_RIGHT':
          topDest -= refHeight + ARROW_HEIGHT;
          leftDest += anchorWidth-refWidth;
          break;
      }
      ref.current.style.top = `${topDest}px`;
      ref.current.style.left = `${leftDest}px`;
    }
  },[anchor, arrow]);
  useEffect(() => {
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [open, onResize]);
  useEffect(()=>{
  }, [anchor, arrow,open]);
  return (
    <>
    <Dimmer tabIndex={1}/>
    <PopoverFrame
      ref={ref}
      className={`arrow-${arrow} ${open && 'open'}`}
      arrow={arrow}
    >
      {children}
    </PopoverFrame>
    </>
  )
};

export default Popover;